<template>
  <div id="advancesComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="expenseSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog
            v-model="dialog"
            max-width="600px"
            persistent
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on">
                <v-icon left>attach_money</v-icon>
                {{ $t('expenses.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-form
                  lazy-validation
                  ref="form"
                  v-model="valid">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md6>
                        <v-menu
                          v-model="start"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              clearable
                              required
                              :rules="rules.required"
                              :error-messages="errors.start_date"
                              v-model="editedItem.start_date"
                              :label="$t('general.startDate')"
                              prepend-icon="event"
                              readonly
                              v-on="on">
                            </v-text-field>
                          </template>
                          <v-date-picker
                            color="primary"
                            :locale="$t('general.locale')"
                            v-model="editedItem.start_date"
                            @input="start = false">
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-menu
                          v-model="end"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              clearable
                              required
                              :rules="rules.required"
                              v-model="editedItem.end_date"
                              :error-messages="errors.end_date"
                              :label="$t('general.endDate')"
                              prepend-icon="event"
                              readonly
                              v-on="on">
                            </v-text-field>
                          </template>
                          <v-date-picker
                            color="primary"
                            :locale="$t('general.locale')"
                            v-model="editedItem.end_date"
                            @input="end = false">
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                        <v-autocomplete
                          v-model="editedItem.user"
                          required
                          :rules="rules.required"
                          :error-messages="errors.user_id"
                          :label="$t('general.employee')"
                          :items="employees"
                          item-text="name"
                          return-object>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="editedItem.project_id"
                          required
                          :rules="rules.required"
                          :error-messages="errors.project_id"
                          :label="$t('general.project')"
                          :items="projects"
                          item-value="id"
                          item-text="name">
                        </v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          clearable
                          required
                          :rules="rules.required"
                          :error-messages="errors.description"
                          :label="$t('general.description')"
                          v-model="editedItem.description">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                        <v-text-field
                          clearable
                          required
                          :error-messages="errors.advance"
                          prepend-icon="attach_money"
                          :persistent-hint="true"
                          :rules="rules.required && rules.decimal"
                          :label="$t('general.advance')"
                          v-model="editedItem.advance">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md 12 v-if="viatics.length > 0">
                        <v-checkbox
                          v-model="editedItem.has_request"
                          :error-messages="errors.has_request"
                          :label="$t('expenses.relateToRequest')">
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm12 md12 v-if="viatics.length > 0 && editedItem.has_request">
                        <v-autocomplete
                          v-model="editedItem.viatic_request_id"
                          :error-messages="errors.viatic_request_id"
                          :label="$t('viatics.title')"
                          :items="viatics"
                          item-value="id"
                          item-text="folio"
                          >
                          <template slot="item" slot-scope="data">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-list-tile-content v-on="on">
                                <v-list-tile-title v-html="data.item.folio"></v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                            <span>
                              <pre style="color: #FFFFFF">{{$t('general.description')}}: {{data.item.description}}</pre>
                              <pre style="color: #FFFFFF">{{$t('general.date')}}: {{data.item.creation_date}}</pre>
                              <pre style="color: #FFFFFF">{{$t('general.amount')}}: $ {{data.item.amount_advance}} MXN</pre>
                            </span>
                          </v-tooltip>
                        </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="save">
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <v-data-table
        :search="expenseSearch"
        class="elevation-2"
        :headers="headers"
        :items="filteredExpenses"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
              >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr v-if="props.item.advance > 0">
            <td class="text-sm-center">{{props.item.user.name}}</td>
            <td class="text-sm-center">{{props.item.created_by ? props.item.created_by.name : '- -'}}</td>
            <td class="text-sm-center">{{props.item.start_date}} /<br>{{props.item.end_date}}</td>
            <td class="text-sm-center">{{props.item.description}}</td>
            <td class="text-sm-center">{{props.item.project.name}}</td>
            <td class="text-sm-center">{{props.item.advance | formatCurrency}}</td>
            <td class="text-sm-center">{{$t('expenses.' + props.item.status_expense.name)}}</td>
            <td class="text-sm-center">
              <v-layout row justify-center v-if="!props.item.gst_expenses_items.length > 0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)">
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="error"
                      v-on="on"
                      @click="deleteItem(props.item)">
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.delete') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="props.item.travel_expenses_request !== null">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="props.item.travel_expenses_request !== null"
                      :disabled="props.item.created_by && props.item.created_by.id !== userLogged.id"
                      small
                      outline
                      icon
                      color="orange"
                      v-on="on"
                      @click="downloadRequest(props.item)">
                      <v-icon small>fas fa-file-invoice-dollar</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('viatics.downloadRequest') }}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog
        persistent
        v-model="removeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('expenses.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('expenses.description') }}: </span>{{editedItem.description}}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('general.employee') }}: </span>{{ editedItem.user !== undefined ? editedItem.user.name : ''}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'advancesComponent',
  data () {
    return {
      expenseSearch: '',
      errors: {},
      loading: false,
      loadingItems: true,
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      timeout: 3000,
      dialog: false,
      removeDialog: false,
      workflowDialog: false,
      start: false,
      end: false,
      valid: true,
      editedIndex: -1,
      editedItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        user: '',
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false
      },
      defaultItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        user: '',
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false
      },
      userLogged: {},
      employees: [],
      expenses: [],
      expensesStatus: [],
      projects: [],
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      viatics: []
    }
  },
  computed: {
    filteredExpenses () {
      return this.expenses.filter(function (el) {
        return el.advance !== '0.00'
      })
    },
    heading () {
      return this.$t('general.advances')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-file-invoice-dollar fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('expenses.new') : this.$t('expenses.edit')
    },
    headers () {
      return [
        {
          text: this.$t('general.user'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: this.$t('general.createdBy'),
          align: 'center',
          value: 'start_date',
          sortable: true
        },
        {
          text: this.$t('setting.st.period'),
          align: 'center',
          value: 'start_date',
          sortable: true
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true
        },
        {
          text: this.$t('general.status'),
          align: 'center',
          value: 'status_expense.name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    removeDialog (val) {
      val || this.closeRemove()
    },
    userLogged () {
      if (this.$store.state.userLogged.company !== undefined) {
        this.get()
        this.getViatics()
      }
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.getLogged()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    downloadRequest (item) {
      this.loadingDownload = true
      this.$emit('downloadRequest', {
        context: this,
        expensesRequest: item.travel_expenses_request.id,
        folio: item.travel_expenses_request.folio
      })
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    deleteItem (item) {
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.removeDialog = true
    },
    removeItem () {
      this.loading = true
      this.delete()
    },
    closeRemove () {
      this.loading = false
      this.removeDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    close () {
      this.loading = false
      this.errors = {}
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
    },
    editItem (item) {
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    showWorkflowDialog (item) {
      this.workflowDialog = true
      this.editedItem = Object.assign({}, item)
    },
    closeWorkflowDialog () {
      this.workflowDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
    },
    get () {
      this.$emit('get', {
        context: this
      })
    },
    getViatics () {
      this.$emit('getViaticsApproved', {
        context: this,
        user_id: this.userLogged.id,
        status: 'APPROVED'
      })
    },
    post () {
      this.$emit('post', {
        item: this.editedItem,
        user: this.editedItem.user,
        context: this
      })
    },
    put () {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    delete () {
      this.$emit('delete', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    startWorkflow () {
      this.$emit('startWorkflow', {
        context: this,
        item: this.editedItem
      })
    },
    refresh () {
      this.$emit('refresh', {
        context: this
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/advances.component.vue